import Head from 'next/head'
import Script from 'next/script'
import { absoluteUrl } from '../../utils/market-schema'
import { s3Static } from '../../utils/constants'

const DEFAULT_OG_IMAGE = s3Static + 'girl-with-stringssg-logo-on-mobile.jpg'

/**
 * <head> for every UAE / Malaysia page: title, description, canonical, Open
 * Graph, hreflang alternates and one JSON-LD @graph.
 *
 * alternates: [{ hreflang: 'en-sg', path: '/sg/...' }, ...]. Include the page
 * itself - hreflang sets must be reciprocal and self-referencing, so every page
 * in a set passes the same list.
 */
export const MarketHead = ({
    market,
    path,
    title,
    description,
    jsonLd,
    alternates = [],
    ogImage = DEFAULT_OG_IMAGE,
    ogImageAlt,
    contentLanguage,
    noindex = false,
}) => {
    const url = absoluteUrl(path)
    const language = contentLanguage || market.hreflang
    const ogLocale = language.replace('-', '_').replace(/_([a-z]+)$/, (m, c) => `_${c.toUpperCase()}`)

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content={description} />
                <meta name="author" content="StringsSG" />
                <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'} />
                <meta httpEquiv="content-language" content={language} />
                <meta property="og:locale" content={ogLocale} />
                <meta property="og:site_name" content="StringsSG" />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={ogImage} />
                {ogImageAlt && <meta property="og:image:alt" content={ogImageAlt} />}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@stringssg" />
                <meta name="twitter:title" content={title} />
                <meta name="twitter:description" content={description} />
                <meta name="twitter:image" content={ogImage} />
                <link rel="icon" href="/favicon.ico" />
                <link rel="canonical" href={url} />
                {alternates.map((alt) => (
                    <link key={alt.hreflang} rel="alternate" hrefLang={alt.hreflang} href={absoluteUrl(alt.path)} />
                ))}
                {jsonLd && (
                    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} />
                )}
            </Head>
            <Script
                id="google-tagmanager-new"
                src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
                strategy="lazyOnload"
                onLoad={() => {
                    window.dataLayer = window.dataLayer || []
                    function gtag() { window.dataLayer.push(arguments) }
                    gtag('js', new Date())
                    gtag('config', 'G-QD1HGGHDYJ')
                }}
            />
        </>
    )
}
